import { useMemo } from "react";
import { usePrintResultDownloadEffect } from "./usePrintResultDownloadEffect";
import { usePrint } from "./usePrint";

export const usePrintDownload = () => {
  const { startPrint, loading, printResult } = usePrint();

  usePrintResultDownloadEffect(printResult);

  return useMemo(() => ({ print: startPrint, printWaiting: loading }), [startPrint, loading]);
};
